import { NgModule } from '@angular/core';
import { UserActivitiesService } from './user-activities.service';
import { UserActivitiesComponent } from './user-activities.component';

import { ActivityPopUpComponent } from './activity-popup.component';
import { SmartEditorComponent } from './smart-editor.component';
import { SearchTypologyComponent } from './search-typology.component';
import { SearchOwnerComponent } from './search-owner.component';
import { SearchCalendarComponent } from './calendar-search.component';

import { SearchComponent } from './party-search.component';
import { ActivityHourChartComponent } from './activity-hour-chart/activity-hourChart.component';
import { ActivityHourPopUpComponent } from './activity-hour-chart/activity-hourPopup.component';
import { ActivityStateChartComponent } from './activity-state-chart/activity-stateChart.component';
import { ActivityStatePopUpComponent } from './activity-state-chart/activity-statePopup.component';
import { ActivityTypologyChartComponent } from './activity-typology-chart/activity-typologyChart.component';
import { ActivityTypologyPopUpComponent } from './activity-typology-chart/activity-typologyPopup.component';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { GridsterModule } from 'angular-gridster2';
import { ToastrModule } from 'ngx-toastr';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressBarModule } from 'primeng/progressbar';
import { RippleModule } from 'primeng/ripple';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { PipesModule } from '../../../pipes/pipes.module';
import { DialogModule } from 'primeng/dialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SkeletonModule } from 'primeng/skeleton';



export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "assets/i18n/");
}

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MultiSelectModule,
        DialogModule,
        CardModule,
        ProgressBarModule,
        GridsterModule,
        CalendarModule,
        InputNumberModule,
        InputSwitchModule,
        InputTextModule,
        RippleModule,
        TableModule,
        SkeletonModule,
        DropdownModule,
        CheckboxModule,
        TooltipModule,
        ChartModule,
        ReactiveFormsModule,
        FormsModule,
        FileUploadModule,
        PipesModule,
        TranslateModule,
        ToastrModule.forRoot({
            timeOut: 2500,
            enableHtml: true,
            positionClass: 'toast-top-right'
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        SearchComponent,
        UserActivitiesComponent,
        ActivityPopUpComponent,
        SmartEditorComponent,
        SearchTypologyComponent,
        SearchOwnerComponent,
        SearchCalendarComponent,
        ActivityHourChartComponent,
        ActivityHourPopUpComponent,
        ActivityStateChartComponent,
        ActivityStatePopUpComponent,
        ActivityTypologyChartComponent,
        ActivityTypologyPopUpComponent
    ],
    providers: [
        UserActivitiesService
    ],
    exports: [
        SearchComponent,
        UserActivitiesComponent,
        ActivityPopUpComponent,
        SmartEditorComponent,
        SearchTypologyComponent,
        SearchOwnerComponent,
        SearchCalendarComponent,
        ActivityHourChartComponent,
        ActivityHourPopUpComponent,
        ActivityStateChartComponent,
        ActivityStatePopUpComponent,
        ActivityTypologyChartComponent,
        ActivityTypologyPopUpComponent,
        FormsModule,
        ReactiveFormsModule
    ],
})

export class UserActivitiesModule {

}
